// tslint:disable: variable-name
import { TWEEN_ONCOMPLETE, TWEEN_ONUPDATE } from "Data/Constants";
import { Horse } from "GameObjects/StoryGame/ch5/Horse";
import { SceneSprite } from "GameObjects/StoryGame/SceneSprite";
import { Expo, Linear, RoughEase, Sine, TimelineLite, TimelineMax, TweenLite, TweenMax } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { AbstractStoryState } from "States/AbstractStoryState";
import { list } from "Utils/Reflection";

import { ch5_p08 } from "../../../layouts/ch5_p08/ch5_p08";

export class Chapter5Page8 extends AbstractStoryState implements ReturnType<typeof ch5_p08> {
    readonly backgroundContainer = this.addChild(new PIXI.Container());
    readonly midgroundContainer = this.addChild(new PIXI.Container());
    readonly foregroundContainer = this.addChild(new PIXI.Container());
    readonly butterflyContainer = this.addChild(new PIXI.Container());
    readonly horse = this.addChild(new Horse());
    readonly extremeForegroundContainer = this.addChild(new PIXI.Container());

    readonly bg = list(() => this.backgroundContainer.addChild(new SceneSprite()));
    readonly butterfly = list(() => this.butterflyContainer.addChild(new SceneSprite()));
    readonly xfg = list(() => this.extremeForegroundContainer.addChild(new SceneSprite()));
    readonly Layer1267 = this.midgroundContainer.addChild(new SceneSprite());
    readonly two = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees9 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees7 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees6 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees5 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees4 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees3 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundtrees1 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middleground5_1 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middleground5_2 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middleground5_3 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middleground5copy_1 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middleground5 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middleground5copy_2 = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middleground5copy = this.midgroundContainer.addChild(new SceneSprite());
    readonly hh_ch5_72dpi_p08psdAssetp08Middlegroundbushes = this.midgroundContainer.addChild(new SceneSprite());
    readonly tractorOpen = this.midgroundContainer.addChild(new SceneSprite());
    readonly tractorClosed = this.midgroundContainer.addChild(new SceneSprite());
    readonly tractorWheels = this.midgroundContainer.addChild(new SceneSprite());
    readonly farmer = this.midgroundContainer.addChild(new SceneSprite());
    readonly fg = list(() => this.foregroundContainer.addChild(new SceneSprite()));
    readonly cowNeutral = this.foregroundContainer.addChild(new SceneSprite());
    readonly cowMooing = this.foregroundContainer.addChild(new SceneSprite());

    protected scrollPercentage: number = 0;
    protected elapsedTime: number = 0;

    protected scrollTimeline?: TimelineLite;
    protected tractorTimeline?: TimelineMax;

    public init(pSize: PIXI.Point, pData: any) {
        // exported layouts from Animate CC
        ch5_p08.call(this);

        this.cowMooing.visible = false;
        this.cowNeutral.interactive = true;
        this.cowNeutral.buttonMode = true;
        this.cowNeutral.accessible = true;
        this.cowNeutral.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
            this.cowNeutral.FadeOut();
            this.cowMooing.FadeIn();
        });

        this.foregroundContainer.setChildIndex(this.cowMooing, this.foregroundContainer.getChildIndex(this.fg[this.fg.length - 1]));
        this.foregroundContainer.setChildIndex(this.cowNeutral, this.foregroundContainer.getChildIndex(this.fg[this.fg.length - 1]));

        this.tractorClosed.visible = false;
        this.tractorOpen.interactive = true;
        this.tractorOpen.buttonMode = true;
        this.tractorOpen.accessible = true;
        this.tractorOpen.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
            this.tractorOpen.FadeOut();
            this.tractorClosed.FadeIn();
            this.tractorTimeline = new TimelineMax();
            this.tractorTimeline
                .to(this.tractorClosed, 10, {pixi: {
                    y: this.tractorClosed.y - 5,
                }, ease: new RoughEase({
                    taper: 'none',
                    points: 200,
                    strength: 2,
                    randomize: false,
                })}, 0);
            this.tractorTimeline.repeat(-1).yoyo(false).repeatDelay(1);
        });

        this.horse.scale.x = -0.2075;
        this.horse.scale.y = 0.2075;
        this.horse.Walk();
        this.horse.update(0);
        this.horse.y = 700; // eyeballed

        this.butterfly.forEach(s=>s.visible = false);
        this.butterfly[0].visible = true;

        TweenMax.to(this.butterflyContainer, 1, {pixi: {y: -20}, ease: Sine.easeInOut}).yoyo(true).repeat(-1);

        // super.init calls onResize
        super.init(pSize, pData);
    }

    public update(pDeltaTime: number) {
        super.update(pDeltaTime);
        this.scroll(this.scrollPercentage);

        this.elapsedTime += pDeltaTime;

        // bit of a hacky way of flipping through an array of sprites but it works...
        const fps = 6;
        if (this.elapsedTime > 1/fps) {
            this.butterfly.push(this.butterfly.shift()!);
            this.butterfly.forEach(s=>s.visible = false);
            this.butterfly[0].visible = true;
            this.elapsedTime = 0;
        }
    }

    public destroy() {
        super.destroy();
        this.tractorTimeline?.kill();
    }

    public animateIn(pOnComplete: () => void) {
        super.animateIn(pOnComplete);

        const introTimeline = new TimelineLite();
        introTimeline.to(this.horse, 4.5, {pixi: {x: 640}, ease: Linear.easeNone});
        introTimeline.call(()=>{
            console.log("pause1");
            this.horse.StopWalking();

            this.butterflyContainer.buttonMode = true;
            this.butterflyContainer.interactive = true;
            this.butterflyContainer.accessible = true;
            this.butterflyContainer.addListener(HLF.Input.Events.POINTER_TAP, ()=>{
                this.scrollTimeline?.resume();
                this.butterflyContainer.interactive = false;
            });
        });
    }

    public animateOut(pOnComplete: () => void) {
        super.animateOut(pOnComplete);
    }

    public onAnimateInComplete() {
        super.onAnimateInComplete();

        this.scrollTimeline = new TimelineLite();
        this.scrollTimeline.paused(true);

        // walk 33% then pause
        this.scrollTimeline.call(()=>{
            this.horse.Trot();
            console.log("resume1");
        });
        this.scrollTimeline.to(this, 8, { scrollPercentage: 1/3, ease: Linear.easeNone });
        this.scrollTimeline.call(()=>{
            this.horse.StopWalking();
            this.butterflyContainer.interactive = true;
            console.log("pause2");
        });
        this.scrollTimeline.addPause();

        // walk another 33% then pause
        this.scrollTimeline.call(()=>{
            this.horse.Trot();
            console.log("resume2");
        });
        this.scrollTimeline.to(this, 8, { scrollPercentage: 2/3, ease: Linear.easeNone });
        this.scrollTimeline.call(()=>{
            this.horse.StopWalking();
            this.butterflyContainer.interactive = true;
            console.log("pause3");
        });
        this.scrollTimeline.addPause();

        // walk another 33% then walk offscreen
        this.scrollTimeline.call(()=>{
            this.horse.Trot();
            console.log("resume3");
        });
        this.scrollTimeline.to(this, 8, { scrollPercentage: 3/3, ease: Linear.easeNone });
        this.scrollTimeline.to(this.horse, 5, {pixi: {x: 2000}, ease: Linear.easeNone});
        this.scrollTimeline.to(this.butterflyContainer, 4, {pixi: {x: 2000}, ease: Linear.easeNone}, "-=5");
        this.scrollTimeline.call(()=>{
            this.gotoNextState({transition: "left"});
        });
    }

    public onResize(pSize: PIXI.Point) {
        super.onResize(pSize);
        this.scroll(this.scrollPercentage);
    }

    protected scroll(percentage: number) {
        this.backgroundContainer.x = percentage * (1664 - this.backgroundContainer.width);
        this.midgroundContainer.x = percentage * (1664 - this.midgroundContainer.width);
        this.foregroundContainer.x = percentage * (1664 - this.foregroundContainer.width);
        this.extremeForegroundContainer.x = percentage * (1664 - this.extremeForegroundContainer.width);
    }
}